<script setup>
// The date page's "Cancellation terms" (owner, 26 Sep 2026: keep the price
// card short). The cancellation table, No-show row included, and the club's
// terms to READ: no tick, since reading them here accepts nothing.
import {computed} from 'vue';
import TlDialog from '~/components/TlDialog.vue';
import MeetTierTable from '~/components/meets/MeetTierTable.vue';
import {cancellationTermsFor, useMeetFormat} from '~/composables/useMeetFormat';
import {MEET_SET_DATE_CANCELLATION_LINE} from '~/composables/useMeetCancellationRight.js';

const props = defineProps({
  modelValue: {type: Boolean, default: false},
  meet: {type: Object, required: true},
  occurrence: {type: Object, default: null},
});
const emit = defineEmits(['update:modelValue']);

const {isPaid, tierRows, termsAsHtml} = useMeetFormat();
// A booked member sees the tiers their booking agreed (myCancellation), which
// is what a late cancellation is charged under; anyone else the meet's own.
const rows = computed(() => tierRows(cancellationTermsFor(props.meet, props.occurrence), props.occurrence));
const hasTerms = computed(() => !!props.meet?.termsHtml?.trim());
</script>

<template>
  <tl-dialog
      :model-value="modelValue"
      title="Cancellation terms"
      :max-width="520"
      @update:model-value="emit('update:modelValue', $event)"
  >
    <!-- A paid date is for a set date: told before booking (CCRs 2013 reg 28(1)(b)). -->
    <p v-if="isPaid(meet)" class="set-date" :class="{'mb-3': rows.length || hasTerms}">{{ MEET_SET_DATE_CANCELLATION_LINE }}</p>
    <meet-tier-table v-if="rows.length" :rows="rows"/>
    <div v-if="hasTerms" class="terms-box" :class="{'mt-3': rows.length}" v-html="termsAsHtml(meet.termsHtml)"/>
  </tl-dialog>
</template>

<style scoped lang="scss">
.set-date {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: rgb(var(--v-theme-charcoal));
}

.terms-box {
  max-height: 320px;
  overflow-y: auto;
  font-size: 12.5px;
  line-height: 1.65;
  color: rgb(var(--v-theme-charcoal));
}
</style>
